import { render, staticRenderFns } from "./AbcInsuranceSelection.vue?vue&type=template&id=1339e71a"
import script from "./AbcInsuranceSelection.vue?vue&type=script&lang=js"
export * from "./AbcInsuranceSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports